import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { FixedAssetRegistryStartingBalanceActionTypes } from "./FixedAssetRegistryStartingBalance.type";

export function* fetchAllFixedAssetRegistryStartingBalances(
  action: any
): any {
  try {
    let query = "";
    if (action.payload) {
      const keys = Object.keys(action.payload);
      query = keys.map((key) => `${key}=${action.payload[key]}`).join("&");
    }
    const response = yield axios.get(
      `${API_BASE_URI}/fixed-asset-registry-starting-balance?${query}`
    );
    yield put({
      type: FixedAssetRegistryStartingBalanceActionTypes
        .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: FixedAssetRegistryStartingBalanceActionTypes
        .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE,
      payload: error,
    });
  }
}

export function* bulkUpsertFixedAssetRegistryStartingBalances(
  action: any
): any {
  try {
    const response = yield axios.post(
      `${API_BASE_URI}/fixed-asset-registry-starting-balance/bulk-upsert`,
      { items: action.payload }
    );
    yield put({
      type: FixedAssetRegistryStartingBalanceActionTypes
        .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: FixedAssetRegistryStartingBalanceActionTypes
        .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllFixedAssetRegistryStartingBalances() {
  yield takeLatest(
    FixedAssetRegistryStartingBalanceActionTypes
      .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE,
    fetchAllFixedAssetRegistryStartingBalances
  );
}

export function* watcherBulkUpsertFixedAssetRegistryStartingBalances() {
  yield takeLatest(
    FixedAssetRegistryStartingBalanceActionTypes
      .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE,
    bulkUpsertFixedAssetRegistryStartingBalances
  );
}
